import { STEPS_STATES } from '~constants/steps';
import { ReactComponent as Cross } from '~assets/error.svg';
import { ReactComponent as Check } from '~assets/check.svg';

export const STEPS_STATES_ICONS = {
  [STEPS_STATES.UNCOMPLETED]: Cross,
  [STEPS_STATES.COMPLETED]: Check
};
